import { t } from "i18next";
import { useEffect, useState } from "react";
import { getSeasons } from "../../../../services/season";
import { Season } from "../../../../interfaces/season";
import DataTable from "react-data-table-component";
import moment from 'moment';
import { Button, Form } from "react-bootstrap";
import { AdminSeasonNew } from "./season-new";
import { AdminSeasonDelete } from "./season-delete";
import { AdminSeasonEdit } from "./season-edit";
import { getPaginationOptions, tableStyles } from "../../../../util/data-table";

export function AdminSeasonList() {
    const [seasons, setSeasons] = useState<Season[]>([]);
    const [showAddNew, setShowAddNew] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [selectedId, setSelectedId] = useState(0);
    
    const CustomDateChangedAt = (row: any ) => (
        <span>
            { moment(row.row.changed_at).format("DD/MM/YYYY HH:mm") }
        </span>
    );

    const CustomDateStart = (row: any ) => (
        <span>
            { moment(row.row.date_start).format("DD/MM/YYYY") }
        </span>
    );

    const CustomDateEnd = (row: any ) => (
        <span>
            { moment(row.row.date_end).format("DD/MM/YYYY") }
        </span>
    );
    
    const CustomActions = (row: any) => (
        <span>
            <a href="#" className="icon-link edit" title={ t("edit") } onClick={ handleEdit } data-id={ row.row.id }>
                <i className="bi bi-pencil-square"></i>
            </a>
            <a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ row.row.id }>
                <i className="bi bi-trash"></i>
            </a>
        </span>
    );

    const CustomIcon = (row: any) => (
        <div className="image">
            { row.row.icon.length > 0 &&
                <img src={ row.row.icon[0].src } alt={ row.row.icon[0].name } />
            }
        </div>
    );

    const columns = [
        {
            id: 'id',
            name: '#',
            selector: (row: any) => row.id,
            sortable: true
        },
        {
            id: 'name',
            name: t("Name"),
            selector: (row: any) => row.name,
            sortable: true
        },
        {
            id: 'date_start',
            name: t('date_start'),
            selector: (row: any) => row.date_start,
            sortable: true,
            cell: (row: any) => <CustomDateStart row={row} />,
        },
        {
            id: 'date_end',
            name: t('date_end'),
            selector: (row: any) => row.date_end,
            sortable: true,
            cell: (row: any) => <CustomDateEnd row={row} />,
        },
        {
            id: 'changed_at',
            name: t('changed_at'),
            selector: (row: any) => row.changed_at,
            sortable: true,
            cell: (row: any) => <CustomDateChangedAt row={row} />,
        },
        {
            id: 'actions',
            name: t("actions"),
            cell: (row: any) => <CustomActions row={row} />,
        }

    ];

    useEffect(() => {
        getSeasons()
            .then(response => {
                setSeasons(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSearchSubmit = (event: any) => {
        event.preventDefault();

        const s = event.target.search.value;

        getSeasons(s)
            .then(response => {
                setSeasons(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAddNew(true)
    }

    const handleAddNewOnSave = (s: Season) => {
        const newSeasons = [
            s,
            ...seasons
        ];
        setSeasons(newSeasons);
        setShowAddNew(false);
    }

    const handleAddNewOnClose = () => {
        setShowAddNew(false);
    }

    const handleDelete = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowDelete(true);
    }

    const handleDeleteOnDelete = (id: number) => {
        setSelectedId(0);
        const newSeasons = seasons.filter((s: Season) => s.id != id);
        setSeasons(newSeasons);
        setShowDelete(false);
    }

    const handleDeleteOnClose = () => {
        setSelectedId(0);
        setShowDelete(false);
    }

    const handleEdit = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowEdit(true);
    }

    const handleEditOnSave = (changedSeason: Season) => {
        setSelectedId(0);
        const newSeasons = seasons.map((s: Season) => {
            if (s.id == changedSeason.id) {
                return changedSeason;
            } else {
                return s;
            }
        });
        setSeasons(newSeasons);
        setShowEdit(false);
    }

    const handleEditOnClose = () => {
        setSelectedId(0);
        setShowEdit(false);
    }

    return (
        <div className="season-list-container">
            <h1>
                { t('seasons')}
            </h1>
            <div className="filters-container">
                <Form onSubmit={ handleSearchSubmit }>
                    <Form.Group className="field-search" controlId="search">
                        <Form.Control type="search" placeholder={ t("Write to search") } />
                    </Form.Group>
                    <div className="actions">
                        <Button variant="primary" type="submit">
                            { t("search") }
                        </Button>
                    </div>
                </Form>
            </div>
            <div className="table-container">
                <DataTable
                    columns={ columns }
                    data={seasons}
                    // selectableRows={ true }
                    // selectableRowsHighlight={ true }
                    responsive={ true }
                    striped={ true }
                    highlightOnHover={ true }
                    defaultSortFieldId={ 'changed_at' }
                    defaultSortAsc={ false }
                    pagination={ true }
                    customStyles={ tableStyles }
                    paginationComponentOptions={ getPaginationOptions() }
                />
            </div>            
            <a className="admin-add-new" href="#" onClick={ handleAddNew }>
                <i className="bi bi-plus-circle"></i>
            </a>
            { showAddNew &&
                <AdminSeasonNew onSave={ handleAddNewOnSave } onClose={ handleAddNewOnClose } />
            }
            { showDelete && (selectedId != 0) &&
                <AdminSeasonDelete id={ selectedId } onDelete={ handleDeleteOnDelete } onClose={ handleDeleteOnClose } />
            }
            { showEdit && (selectedId != 0) &&
                <AdminSeasonEdit id={ selectedId } onSave={ handleEditOnSave } onClose={ handleEditOnClose } />
            }
        </div>

    )
}